import { NavLink } from "react-router-dom";
import { Inbox, Radio, Mail, Users, Grid3X3, Workflow, BarChart3, DatabaseBackup, ScrollText, Settings2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

const SECTIONS = [
  { label: "Work", items: [
    { to: "/tickets", label: "Tickets", icon: Inbox, testId: "nav-tickets" },
    { to: "/board", label: "Live board", icon: Radio, perm: "board.view", testId: "nav-board" },
  ] },
  { label: "Configure", items: [
    { to: "/channels", label: "Channels", icon: Mail, perm: "channels.manage", testId: "nav-channels" },
    { to: "/users", label: "Users", icon: Users, perm: "users.manage", testId: "nav-users" },
    { to: "/permissions", label: "Permission matrix", icon: Grid3X3, perm: "permissions.manage", testId: "nav-permissions" },
    { to: "/automation", label: "Automation & alerts", icon: Workflow, perm: "rules.manage", testId: "nav-automation" },
    { to: "/reports", label: "Reports", icon: BarChart3, perm: "reports.view", testId: "nav-reports" },
  ] },
  { label: "System", items: [
    { to: "/backups", label: "Snapshots & restore", icon: DatabaseBackup, perm: "backups.manage", testId: "nav-backups" },
    { to: "/audit", label: "Audit log", icon: ScrollText, perm: "audit.view", testId: "nav-audit" },
    { to: "/settings", label: "Settings", icon: Settings2, perm: "settings.manage", testId: "nav-settings" },
  ] },
];

export default function NavRail({ onNavigate, className }) {
  const { can } = useAuth();
  return (
    <nav className={cn("flex w-56 shrink-0 flex-col gap-5 border-r border-border bg-card px-3 py-4", className)} data-testid="nav-rail">
      {SECTIONS.map((s) => {
        const items = s.items.filter((i) => !i.perm || can(i.perm));
        if (!items.length) return null;
        return (
          <div key={s.label}>
            <div className="eyebrow mb-1.5 px-2">{s.label}</div>
            <ul className="space-y-0.5">
              {items.map((i) => (
                <li key={i.to}>
                  <NavLink to={i.to} onClick={onNavigate} data-testid={i.testId}
                    className={({ isActive }) => cn("flex items-center gap-2.5 border-l-2 px-2 py-1.5 text-[13px] font-medium transition-colors",
                      isActive ? "border-primary bg-accent text-foreground" : "border-transparent text-muted-foreground hover:bg-accent/60 hover:text-foreground")}>
                    <i.icon className="h-4 w-4" strokeWidth={1.75} /> {i.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
      <div className="mt-auto px-2">
        <div className="eyebrow">Retention</div>
        <div className="mt-1 text-[11px] text-muted-foreground">Tickets are never deleted. Closed tickets live in the archive forever.</div>
      </div>
    </nav>
  );
}
